import { IOSMResponse } from "@eventr/common";
import { ColoursObj, Icon } from "@eventr/common-storybook";
import { CardText } from "../subComponents/cardText";
import { RowInfo } from "../subComponents/rowInfo";
import { RowInfoAddress } from "../subComponents/rowInfoAddress";

interface IActivityExtraInfoProps {
  location?: string;
  address?: IOSMResponse;
}

export const ActivityExtraInfo = ({ location, address }: IActivityExtraInfoProps) => {
  return (
    <>
      {/* The location is a hall/stand reference, not prose, so it renders as plain text. Every
          one of the 3,366 stands on the IMEX import was running a second full react-markdown
          pipeline here on a string that never contains markdown. */}
      {location && (
        <RowInfo
          start={<Icon bubble bubbleColour={ColoursObj.coreBrights.secondary} name="Location" />}
          middle={<CardText>{location}</CardText>}
        />
      )}
      {address && <RowInfoAddress address={address} />}
    </>
  );
};
